import { Utils, UI } from '@pacem/pacem-core';
import { Rect } from '@pacem/pacem-foundation';
import { StageEvent, DrawableEvent, DragEvent } from '../drawing';
//namespace Pacem.Components.Drawing {
export class AdapterUtils {
    static stageDispatch(stage, type, evt) {
        if (stage instanceof EventTarget) {
            stage.dispatchEvent(new StageEvent('stage' + type, stage, evt, stage.transformMatrix));
        }
    }
    static isValidViewbox(viewbox) {
        return !Utils.isNullOrEmpty(viewbox) && Rect.isRect(viewbox) && Number.isFinite(viewbox.x) // isFinite includes NaN check
            && Number.isFinite(viewbox.y) && Number.isFinite(viewbox.width) && Number.isFinite(viewbox.height);
    }
    static itemDispatch(target, type, offset) {
        if (Utils.isNull(target?.stage)) {
            return false;
        }
        var dragArgs, originalEvent, evtType;
        if (offset instanceof Event) {
            originalEvent = offset;
        }
        else {
            dragArgs = { item: target, offset: offset };
        }
        if (typeof type === 'string') {
            evtType = type;
        }
        else {
            evtType = type.type;
            originalEvent = type.originalEvent;
        }
        const m = target.stage.transformMatrix;
        const evt = () => offset instanceof Event
            ? new DrawableEvent(evtType, target, originalEvent, m)
            : new DragEvent(evtType, { detail: dragArgs, cancelable: evtType === UI.DragDropEventType.Init || evtType === UI.DragDropEventType.Drag }, originalEvent, m);
        const itemevt = offset instanceof Event
            ? new DrawableEvent('item' + evtType, target, originalEvent, m)
            : new DragEvent('item' + evtType, { detail: dragArgs, cancelable: evtType === UI.DragDropEventType.Init || evtType === UI.DragDropEventType.Drag }, originalEvent, m);
        var prevent = false;
        if (target instanceof EventTarget) {
            const evnt = evt();
            target.dispatchEvent(evnt);
            prevent = evnt.defaultPrevented;
        }
        target.stage.dispatchEvent(itemevt);
        // was the event (in one of its forms) rejected?
        return prevent || itemevt.defaultPrevented;
    }
}
